export class themeSliders {
	constructor(config = {}) {
		if (!window.slidersInitialized) {
			// Store carousel navigation class configuration
			this.carouselNavConfig = config.carouselNavClasses || {};
			this.init();
			window.slidersInitialized = true;
		}
	}

	async init() {
		const { default: Swiper } = await import('swiper');
		const { Pagination, Navigation } = await import('swiper/modules');

		// Initialize existing Swiper containers
		const swiperContainers = document.querySelectorAll('[data-slidername]');

		// Initialize Bootstrap carousels
		const bootstrapCarousels = document.querySelectorAll('.carousel.slide');

		if (swiperContainers.length > 0) {
			swiperContainers.forEach((container) => {
				const sliderName = container.dataset.slidername;
				let options = {};

				// Ensure container has an ID
				if (!container.id) {
					container.id = `slider-${sliderName}-${Math.floor(
						Math.random() * 10000
					)}`;
				}

				const containerId = `#${container.id}`;

				if (sliderName === 'largePostSlider') {
					options = {
						modules: [Navigation, Pagination],
						centeredSlides: false,
						slideToClickedSlide: false,
						loop: false,
						spaceBetween: 0,
						slidesPerView: 1,
						pagination: {
							el: `${containerId} .swiper-pagination`,
							clickable: true,
						},
						navigation: {
							nextEl: `.largepostslider-swiper-button-next`,
							prevEl: `.largepostslider-swiper-button-prev`,
						},
						resizeObserver: true,
						updateOnWindowResize: true,
						observer: true,
						observeParents: true,
						breakpoints: {
							1280: {
								width: 1040,
								gap: 64,
							},
							1024: {
								width: 784,
							},
							768: {
								width: 518,
							},
							640: {
								width: 500,
							},
							475: {
								width: 335,
							},
							0: {

							}
						},
					};
					new Swiper(container, options);
				}
				if (sliderName === 'gallerySlider') {
					options = {
						modules: [Navigation, Pagination],
						centeredSlides: true,
						loop: false,
						spaceBetween: 0,
						slidesPerView: 1,
						pagination: {
							el: `${containerId} .swiper-pagination`,
							clickable: true,
						},
						navigation: {
							nextEl: `${containerId} .swiper-button-next`,
							prevEl: `${containerId} .swiper-button-prev`,
						},
					};
					new Swiper(container, options);
				}
				if (sliderName === 'companyGallery') {
					this.initCompanyGallery(container, Swiper, [
						Navigation,
						Pagination,
					]);
				}
				if (sliderName === 'weddingguide-slide-carousel') {
					this.initWeddingguideEvents(container, Swiper, [
						Navigation,
						Pagination,
					]);
				}
				if (sliderName === 'swiper-aanbieder') {
					options = {
						modules: [Navigation, Pagination],
						centeredSlides: false,
						loop: false,
						spaceBetween: 16,
						// slidesPerView: 1.1,
						navigation: {
							nextEl: `${containerId} .swiper-button-next`,
							prevEl: `${containerId} .swiper-button-prev`,
						},
						pagination: {
							el: `${containerId} .swiper-pagination`,
							clickable: true,
						},
						resizeObserver: true,
						updateOnWindowResize: true,
						observer: true,
						observeParents: true,
						breakpoints: {
							1280: {
								width: 350
							},
							1024: {
								width: 350
							},
							768: {
								width: 350
							},
							640: {
								width: 290
							},
							475: {
								width: 290
							},
							0: {
								width: 290
							}
						},
					};
					new Swiper(container, options);
				}
				if (sliderName === 'google-reviews') {
					options = {
						modules: [Navigation, Pagination],
						centeredSlides: false,
						loop: false,
						spaceBetween: 0,
						slidesPerView: 1,
						navigation: {
							nextEl: `${containerId} .google-reviews-swiper-button-next`,
							prevEl: `${containerId} .google-reviews-swiper-button-prev`,
						},
						breakpoints: {
							1024: {
								slidesPerView: 'auto',
								spaceBetween: 0,
							},
							768: {
								slidesPerView: 1.1,
								spaceBetween: 24,
							},
							640: {
								slidesPerView: 1.1,
								spaceBetween: 20,
							},
							0: {
								slidesPerView: 1.1,
								spaceBetween: 16,
							},
						},
					};
					new Swiper(container, options);
				}
			});
		}

		// Convert Bootstrap carousels to Swiper
		if (bootstrapCarousels.length > 0) {
			bootstrapCarousels.forEach((carousel) => {
				this.convertBootstrapToSwiper(carousel, Swiper, [
					Navigation,
					Pagination,
				]);
			});
		}
	}

	convertBootstrapToSwiper(carousel, Swiper, modules) {
		// Ensure carousel has an ID
		if (!carousel.id) {
			carousel.id = `bootstrap-carousel-${Math.floor(
				Math.random() * 10000
			)}`;
		}

		const containerId = `#${carousel.id}`;

		// Get custom classes from data attributes or configuration
		let customNavClasses = carousel.dataset.swiperNavClasses || '';
		let customPrevClasses = carousel.dataset.swiperPrevClasses || '';
		let customNextClasses = carousel.dataset.swiperNextClasses || '';

		// Check if there's a configuration for this specific carousel
		if (this.carouselNavConfig) {
			// Try to find config by carousel ID
			const carouselConfig = this.carouselNavConfig[`#${carousel.id}`] ||
				this.carouselNavConfig[carousel.id] ||
				this.carouselNavConfig['default'];

			if (carouselConfig) {
				customNavClasses = carouselConfig.navClasses || customNavClasses;
				customPrevClasses = carouselConfig.prevClasses || customPrevClasses;
				customNextClasses = carouselConfig.nextClasses || customNextClasses;
			}
		}

		// Convert Bootstrap structure to Swiper structure
		const carouselInner = carousel.querySelector('.carousel-inner');
		const carouselItems = carousel.querySelectorAll('.carousel-item');

		if (!carouselInner || carouselItems.length === 0) {
			return;
		}

		const carouselIndicators = carousel.querySelector(
			'.carousel-indicators'
		);
		const prevControl = carousel.querySelector('.carousel-control-prev');
		const nextControl = carousel.querySelector('.carousel-control-next');

		// Convert carousel-inner to swiper-wrapper
		carouselInner.classList.remove('carousel-inner');
		carouselInner.classList.add('swiper-wrapper');

		// Convert carousel-items to swiper-slides
		carouselItems.forEach((item, index) => {
			item.classList.remove('carousel-item');
			item.classList.add('swiper-slide');
			// Remove active class - Swiper will handle this
			if (index === 0) {
				item.classList.remove('active');
			}
		});

		// Convert indicators to pagination
		let hasPagination = false;
		if (carouselIndicators) {
			carouselIndicators.classList.remove('carousel-indicators');
			carouselIndicators.classList.add('swiper-pagination');
			// Clear Bootstrap indicator structure
			carouselIndicators.innerHTML = '';
			hasPagination = true;
		}

		// Convert controls to navigation
		let hasNavigation = false;
		if (prevControl && nextControl) {
			prevControl.classList.remove('carousel-control-prev');
			prevControl.classList.add('swiper-button-prev');
			prevControl.removeAttribute('href');
			prevControl.removeAttribute('role');
			prevControl.removeAttribute('data-bs-slide');

			nextControl.classList.remove('carousel-control-next');
			nextControl.classList.add('swiper-button-next');
			nextControl.removeAttribute('href');
			nextControl.removeAttribute('role');
			nextControl.removeAttribute('data-bs-slide');

			// Add custom classes to both navigation buttons
			if (customNavClasses) {
				const navClasses = customNavClasses.split(' ').filter(c => c);
				navClasses.forEach(cls => {
					prevControl.classList.add(cls);
					nextControl.classList.add(cls);
				});
			}

			// Add custom class to prev button
			if (customPrevClasses) {
				const prevClasses = customPrevClasses.split(' ').filter(c => c);
				prevClasses.forEach(cls => prevControl.classList.add(cls));
			}

			// Add custom class to next button
			if (customNextClasses) {
				const nextClasses = customNextClasses.split(' ').filter(c => c);
				nextClasses.forEach(cls => nextControl.classList.add(cls));
			}

			// Handle icons
			const prevIcon = prevControl.querySelector(
				'.carousel-control-prev-icon'
			);
			const nextIcon = nextControl.querySelector(
				'.carousel-control-next-icon'
			);

			// Get icon classes from config
			const carouselConfig = this.carouselNavConfig ?
				(this.carouselNavConfig[`#${carousel.id}`] ||
					this.carouselNavConfig[carousel.id] ||
					this.carouselNavConfig['default']) : null;

			const prevIconClasses = carouselConfig?.prevIconClasses || '';
			const nextIconClasses = carouselConfig?.nextIconClasses || '';
			const navIconClasses = carouselConfig?.navIconClasses || '';
			const customPrevSvg = carouselConfig?.prevSvg || '';
			const customNextSvg = carouselConfig?.nextSvg || '';
			const customNavSvg = carouselConfig?.navSvg || '';
			const navSvgClasses = carouselConfig?.navSvgClasses || '';
			const prevSvgClasses = carouselConfig?.prevSvgClasses || '';
			const nextSvgClasses = carouselConfig?.nextSvgClasses || '';

			// Handle prev button content
			if (customPrevSvg || customNavSvg) {
				// Use custom SVG
				const svgContent = customPrevSvg || customNavSvg;
				const svgClassList = [navSvgClasses, prevSvgClasses].filter(c => c).join(' ');

				// Wrap SVG with class if needed
				if (svgClassList) {
					// Add classes to the SVG element
					const tempDiv = document.createElement('div');
					tempDiv.innerHTML = svgContent.trim();
					const svgElement = tempDiv.querySelector('svg');
					if (svgElement) {
						svgClassList.split(' ').filter(c => c).forEach(cls => svgElement.classList.add(cls));
						prevControl.innerHTML = svgElement.outerHTML;
					} else {
						prevControl.innerHTML = svgContent;
					}
				} else {
					prevControl.innerHTML = svgContent;
				}
			} else if (prevIcon) {
				// Remove Bootstrap classes
				prevIcon.classList.remove('carousel-control-prev-icon');

				// Add custom icon classes
				if (navIconClasses) {
					navIconClasses.split(' ').filter(c => c).forEach(cls => prevIcon.classList.add(cls));
				}
				if (prevIconClasses) {
					prevIconClasses.split(' ').filter(c => c).forEach(cls => prevIcon.classList.add(cls));
				}

				// Only add inline styles if no custom classes provided
				if (!navIconClasses && !prevIconClasses) {
					prevIcon.style.display = 'inline-block';
					prevIcon.style.width = '20px';
					prevIcon.style.height = '20px';
				}
			} else if (!prevControl.innerHTML.trim()) {
				// Add fallback arrow content if empty
				const arrowClasses = navIconClasses || prevIconClasses || '';
				if (arrowClasses) {
					prevControl.innerHTML = `<span class="${arrowClasses}">‹</span>`;
				} else {
					prevControl.innerHTML = '<span style="font-size: 18px; color: var(--wp--preset--color--link);">‹</span>';
				}
			}

			// Handle next button content
			if (customNextSvg || customNavSvg) {
				// Use custom SVG
				const svgContent = customNextSvg || customNavSvg;
				const svgClassList = [navSvgClasses, nextSvgClasses].filter(c => c).join(' ');

				// Wrap SVG with class if needed
				if (svgClassList) {
					// Add classes to the SVG element
					const tempDiv = document.createElement('div');
					tempDiv.innerHTML = svgContent.trim();
					const svgElement = tempDiv.querySelector('svg');
					if (svgElement) {
						svgClassList.split(' ').filter(c => c).forEach(cls => svgElement.classList.add(cls));
						nextControl.innerHTML = svgElement.outerHTML;
					} else {
						nextControl.innerHTML = svgContent;
					}
				} else {
					nextControl.innerHTML = svgContent;
				}
			} else if (nextIcon) {
				// Remove Bootstrap classes
				nextIcon.classList.remove('carousel-control-next-icon');

				// Add custom icon classes
				if (navIconClasses) {
					navIconClasses.split(' ').filter(c => c).forEach(cls => nextIcon.classList.add(cls));
				}
				if (nextIconClasses) {
					nextIconClasses.split(' ').filter(c => c).forEach(cls => nextIcon.classList.add(cls));
				}

				// Only add inline styles if no custom classes provided
				if (!navIconClasses && !nextIconClasses) {
					nextIcon.style.display = 'inline-block';
					nextIcon.style.width = '20px';
					nextIcon.style.height = '20px';
				}
			} else if (!nextControl.innerHTML.trim()) {
				// Add fallback arrow content if empty
				const arrowClasses = navIconClasses || nextIconClasses || '';
				if (arrowClasses) {
					nextControl.innerHTML = `<span class="${arrowClasses}">›</span>`;
				} else {
					nextControl.innerHTML = '<span style="font-size: 18px; color: var(--wp--preset--color--link);">›</span>';
				}
			}

			// Only add inline styles if no custom classes are provided
			if (!customNavClasses && !customPrevClasses && !customNextClasses) {
				// Ensure buttons are visible with basic styling
				prevControl.style.display = 'flex';
				prevControl.style.alignItems = 'center';
				prevControl.style.justifyContent = 'center';
				prevControl.style.opacity = '1';
				prevControl.style.visibility = 'visible';

				nextControl.style.display = 'flex';
				nextControl.style.alignItems = 'center';
				nextControl.style.justifyContent = 'center';
				nextControl.style.opacity = '1';
				nextControl.style.visibility = 'visible';
			}

			hasNavigation = true;
		}

		// Remove Bootstrap attributes
		carousel.removeAttribute('data-bs-ride');
		carousel.removeAttribute('data-bs-interval');
		carousel.classList.remove('carousel', 'slide');
		carousel.classList.add('swiper');

		// Initialize Swiper with appropriate options
		const swiperOptions = {
			modules,
			slidesPerView: 1,
			spaceBetween: 0,
			loop: false,
			centeredSlides: true,
			resizeObserver: true,
			updateOnWindowResize: true,
			observer: true,
			observeParents: true,
		};

		// Add pagination if indicators were present
		if (hasPagination) {
			swiperOptions.pagination = {
				el: `${containerId} .swiper-pagination`,
				clickable: true,
			};
		}

		// Add navigation if controls were present
		if (hasNavigation) {
			swiperOptions.navigation = {
				nextEl: `${containerId} .swiper-button-next`,
				prevEl: `${containerId} .swiper-button-prev`,
			};
		}

		// Initialize the Swiper instance
		const swiperInstance = new Swiper(carousel, swiperOptions);

		return swiperInstance;
	}

	initWeddingguideEvents(container, Swiper, modules) {
		// Ensure container has an ID
		if (!container.id) {
			container.id = `slider-weddingguideEvents-${Math.floor(
				Math.random() * 10000
			)}`;
		}
		const containerId = `#${container.id}`;

		let swiper = null;
		let init = false;

		// Function to initialize or destroy Swiper based on screen size
		function swiperMode() {
			const mobile = window.matchMedia('(max-width: 1023px)');
			const desktop = window.matchMedia('(min-width: 1024px)');

			// Enable for mobile
			if (mobile.matches) {
				if (!init) {
					init = true;
					swiper = new Swiper(container, {
						modules,
						centeredSlides: false,
						loop: false,
						spaceBetween: 8,
						slidesPerView: 1.1,
						navigation: {
							nextEl: `${containerId} .swiper-button-next`,
							prevEl: `${containerId} .swiper-button-prev`,
						},
						pagination: {
							el: `${containerId} .swiper-pagination`,
							clickable: true,
						},
						resizeObserver: true,
						updateOnWindowResize: true,
						observer: true,
						observeParents: true,
					});
				}
			}
			// Disable for desktop
			else if (desktop.matches) {
				if (init && swiper !== null) {
					swiper.destroy(true, true);
					swiper = null;
					init = false;
				}
			}
		}
		// Initialize on load
		swiperMode();

		// Reinitialize on window resize
		window.addEventListener('resize', function () {
			swiperMode();
		});
	}

	initCompanyGallery(container, Swiper, modules) {
		// Ensure container has an ID
		if (!container.id) {
			container.id = `slider-companyGallery-${Math.floor(
				Math.random() * 10000
			)}`;
		}

		const containerId = `#${container.id}`;

		let swiper = null;
		let init = false;

		// Function to initialize or destroy Swiper based on screen size
		function swiperMode() {
			const mobile = window.matchMedia('(max-width: 1023px)');
			const desktop = window.matchMedia('(min-width: 1024px)');

			// Enable for mobile
			if (mobile.matches) {
				if (!init) {
					init = true;
					swiper = new Swiper(container, {
						modules,
						centeredSlides: true,
						loop: false,
						spaceBetween: 8,
						slidesPerView: 1.1,
						navigation: {
							nextEl: `${containerId} .swiper-button-next`,
							prevEl: `${containerId} .swiper-button-prev`,
						},
						pagination: {
							el: `${containerId} .swiper-pagination`,
							clickable: true,
						},
						resizeObserver: true,
						updateOnWindowResize: true,
						observer: true,
						observeParents: true,
					});
				}
			}
			// Disable for desktop
			else if (desktop.matches) {
				if (init && swiper !== null) {
					swiper.destroy(true, true);
					swiper = null;
					init = false;
				}
			}
		}

		// Initialize on load
		swiperMode();

		// Reinitialize on window resize
		window.addEventListener('resize', function () {
			swiperMode();
		});
	}
}



const sliderConfig = {
	carouselNavClasses: {
		default: {
			navClasses: 'size-8 max-h-8 max-w-8 flex items-center justify-center bg-dark-500 text-white border-0',
			prevClasses: 'left-4 -scale-x-100',
			nextClasses: 'right-4',
			navIconClasses: 'hidden',
			prevIconClasses: '',
			nextIconClasses: '',
		},
	}
};
new themeSliders(sliderConfig);
